<div
  class="select"
  [class]="class"
  [class.placeholderShown]="!value"
  (click)="toggleDatepicker()"
  (clickOutside)="closeDatepicker()"
>
  <div class="select__wrap" [class.active]="isDatepickerOpen">
    <div class="select__title">
      {{ value || placeholder }}
      <img
        src="assets/icons/dropdown-arrow-blue.svg"
        alt=""
        class="select__arrow"
        [class.active]="isDatepickerOpen"
      />
    </div>

    <div class="select__list" [class.active]="isDatepickerOpen">
      <div class="input-box-container">
        <input
          angular-mydatepicker
          #datepicker="angular-mydatepicker"
          name="datepicker"
          [options]="DATEPICKER_OPTIONS"
          class="input-box"
          (dateChanged)="onDateChanged($event)"
        />
      </div>
    </div>
  </div>
</div>
